import './polyfills/CustomEvent'
import { LuminousGallery } from 'luminous-lightbox'
import Slider from './App/Sliders'
import Prices from './App/Prices'
import Stocks from './App/Stocks'
import Header from './App/Header'
import AddToCart from './App/AddToCart'
import AvailabilityAlert from './App/AvailabilityAlert'
import Session from './App/Session'
import AdminLinks from './App/AdminLinks'
import GoogleTagManager from './App/GoogleTagManager/GoogleTagManager'
import CookiesConsent from './App/CookiesConsent'
import CitySelector from './App/CitySelector'
import ToggleElement from './App/ToggleElement'
import NewsletterForm from './App/NewsletterForm'
import LoadAddress from './App/LoadAddress'
import MainMenu from './App/MainMenu'
import OrderForm from './App/OrderForm'
import Blog from './App/Blog'
import Expand from './App/Expand'
import SearchForm from './App/SearchForm'
import GoTo from './App/GoTo'
import RegisterForm from './App/RegisterForm'
import Dropdown from './App/Dropdown'
import ContactForm from './App/ContactForm'
import Breakpoints from './App/Breakpoints'
import { WindowOrientation } from './App/WindowOrientation'
import Modals from './App/Modals'
import UnavailableProductModal from './App/UnavailableProductModal'
import ProductPreviews from './App/ProductPreviews'
import ProductReviews from './App/ProductReviews'
import AskReplacementModal from './App/AskReplacementModal'
import updateNotification from './App/MessageNotification'
import LazyLoad from 'vanilla-lazyload'
import * as Sentry from "@sentry/browser"
import { Integrations } from "@sentry/tracing"
import uniqid from 'uniqid'

if (window.isProduction) {
    Sentry.init({
        dsn: `https://cf090de51e8f4401ab6a332f4d450a59@o468496.ingest.sentry.io/5496419`,
        integrations: [new Integrations.BrowserTracing()],
    })
}

window.modalInstances = []

Session.request()
window.lazyLoad = new LazyLoad({
    elements_selector: `img.lazy`
})

window.onbeforeprint = () => {
    window.lazyLoad.loadAll()
}

const addToCartForms = [...document.querySelectorAll(`form.add_to_cart`)]

addToCartForms.forEach(form => {
    new AddToCart(form)
})

const availabilityAlertForms = [...document.querySelectorAll(`form.availability-alert`)]

availabilityAlertForms.forEach(form => {
    new AvailabilityAlert(form)
})

new Header()
new Prices()
new Stocks()
new AdminLinks()
new GoogleTagManager()
new CookiesConsent()
new NewsletterForm()
new OrderForm()
new LoadAddress()
new SearchForm()
new Breakpoints()
new Blog()
new ContactForm()
new UnavailableProductModal()
new AskReplacementModal()

const mainMenu = document.querySelector(`.js-MainMenu`)
if (mainMenu) {
    new MainMenu(mainMenu)
}

const zipInputs = [...document.querySelectorAll(`.js-InputZip`)]

zipInputs.forEach(input => {
    new CitySelector(input)
})

const toggleElements = [...document.querySelectorAll(`.js-ToggleElement`)]

toggleElements.forEach(trigger => {
    new ToggleElement(trigger)
})

const goToSelects = [...document.querySelectorAll(`.js-GoTo`)]

goToSelects.forEach(select => {
    new GoTo(select)
})

const expands = [...document.querySelectorAll(`.js-Expand`)]

expands.forEach(trigger => {
    new Expand(trigger)
})

const registerForms = [...document.querySelectorAll(`.js-RegisterForm`)]

registerForms.forEach(form => {
    new RegisterForm(form)
})

const productPreviews = [...document.querySelectorAll(`.js-ProductPreviews`)]

productPreviews.forEach(element => {
    new ProductPreviews(element)
})

const productReviews = [...document.querySelectorAll(`.js-Product__Reviews-Trigger`)]

productReviews.forEach(trigger => {
    new ProductReviews(trigger)
})

const galleries = document.querySelectorAll(`[data-fancybox="gallery"]`)
new LuminousGallery(galleries)

const dropdowns = [...document.querySelectorAll(`.js-Dropdown`)]

dropdowns.forEach(dropdown => {
    new Dropdown(dropdown, dropdowns)
})

updateNotification()

new WindowOrientation
new Modals

document.addEventListener(`DOMContentLoaded`, e => {
    const sliders = [...document.querySelectorAll(`.js-slider`)]
    sliders.forEach(element => {
        element.id = `slider-${uniqid()}`
        const slider = new Slider(element.id, {
            slideBy : 'page',
            controls : false,
            autoplayButtonOutput : false,
        })
    })
})
